import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

// Historico dos e-mails de contrato ativo (designer/atendente, representante e financeiro)
export default class EmailsAutomaticosServices {
	listar (filtros = {}) {
		return new Promise((resolve, reject) => {
			axios.get(`${REQUEST_URL}/emails-automaticos`, {
				params: filtros,
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	reenviar (id) {
		return new Promise((resolve, reject) => {
			axios.post(`${REQUEST_URL}/emails-automaticos/${id}/reenviar`, {}, {
				headers: {"Authorization": localStorage.getItem("token")}
			}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./src/services/emailsAutomaticos.js